export const colors = {
  pageBg:        '#F8F7F4',
  surface:       '#FFFFFF',
  border:        '#E8E4DE',
  borderLight:   '#F0EDE8',
  accent:        '#EF9F27',
  accentDark:    '#BA7517',
  accentMuted:   '#FAEEDA',
  accentText:    '#854F0B',
  textPrimary:   '#1A1714',
  textSecondary: '#444441',
  textMuted:     '#888780',
  textHint:      '#B4B2A9',
  success:       '#639922',
  danger:        '#993C1D',
  info:          '#378ADD',
} as const;
